import { createMuiTheme } from "@material-ui/core";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#283593",
    },
    secondary: {
      main: "#ff6e40",
    },
  },
});

export default theme;
